import React from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Button, Icon, Text } from '@chakra-ui/react';

import { updateCompanyInsuredsTab } from '../../../../../../redux/modules/jobs';
import { multiSelectInsuredsOptions } from '../util';

function EmptyInsuredsList() {
  const dispatch = useDispatch();

  return (
    <Box p={8} textAlign="center" w="100%">
      <Text color="greyScale.900" mb={2} textStyle="bodyLg500">Insured is already on this project or does not exist in the account</Text>
      <Text mb={8} textStyle="bodyMd">Click the button below to Quick-Add a new insured</Text>

      <Button
        leftIcon={<Icon as={BsPlusLg} />}
        variant="secondary"
        onClick={() => dispatch(updateCompanyInsuredsTab(
          multiSelectInsuredsOptions.addNew.key
        ))}
      >
        Add New Insured
      </Button>
    </Box>
  );
}

export default EmptyInsuredsList;
